<template>
  <main-rent :header="header" :first-available="firstAvailable">
    <size-and-delivery :rent-type="'tryOn'" :first-available="firstAvailable" />
    <rent-period :rent-type="'tryOn'" />
    <payment :rent-type="'tryOn'" />
  </main-rent>
</template>

<script>
import MainRent from './MainRent.vue'
import { SizeAndDelivery, RentPeriod, Payment } from 'theme/components/core/blocks/Product-v2/Rent/components'
import { mapGetters } from 'vuex'

export default {
  name: 'TryOn',
  components: {
    MainRent,
    SizeAndDelivery,
    RentPeriod,
    Payment
  },
  props: {
    firstAvailable: {
      type: String,
      default: ''
    }
  },
  computed: {
    ...mapGetters({
      getCurrentProduct: 'product/getCurrentProduct'
    }),
    header () {
      return {
        mainTitle: 'Nie jesteś pewna rozmiaru',
        subtitle: 'Try on 2 items',
        price: this.tryOnPrice
      }
    },
    tryOnPrice () {
      let price = this.getCurrentProduct.sirental_price && this.getCurrentProduct.sirental_price.find(x => x.period === 2 + 'd')
      return price
        ? price.price
        : ''
    }
  }
}
</script>
